export default __webpack_public_path__ + "static/hero-bg-min-b972464ec7869ef570643fbc7f57036f.jpg";